var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1334 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.07674 8.64488L11.339 4.3826C11.4909 4.23073 11.7371 4.23073 11.889 4.3826L12.164 4.65759C12.3158 4.80946 12.3158 5.05569 12.164 5.20756L7.7642 9.60733C7.38453 9.98701 6.76895 9.98701 6.38927 9.60733L1.9895 5.20756C1.83763 5.05569 1.83763 4.80946 1.9895 4.65759L2.26448 4.3826C2.41636 4.23073 2.66259 4.23073 2.81446 4.3826L7.07674 8.64488Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowDown);
export default __webpack_public_path__ + "static/media/icon-arrow-down.85098bec3e92c3b1885274781be449ba.svg";
export { ForwardRef as ReactComponent };